import { useQuery } from 'react-query-v5';
import { dateFormats, TimeLocale } from '@spendbrain/config/dates';

const getAcceptLanguages = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.navigator !== 'undefined'
  ) {
    return Promise.resolve(window.navigator.languages);
  }

  return Promise.resolve([TimeLocale.EnUs]);
};

const isProperLocale = (locale?: string): locale is TimeLocale =>
  locale ? Object.keys(dateFormats).includes(locale) : false;

export const useDateFormat = () => {
  const { data } = useQuery({
    queryKey: ['acceptLanguages'],
    queryFn: getAcceptLanguages,
  });

  const browserLocale = data?.[0];

  const browserPropareLocale = isProperLocale(browserLocale)
    ? browserLocale
    : TimeLocale.EnUs;

  return dateFormats[browserPropareLocale];
};
